import React, { useReducer, createContext } from "react";
import { movieReducer, movieInitialState } from "../reducers";
import constant from "../constants/movieConstant";
import { movieService } from "../services";
import { toast } from "react-toastify"
import { history } from "../tools";

export const MovieContext = createContext();

export const MovieContextProvider = (props) => {

    const [state, dispatch] = useReducer(movieReducer, movieInitialState);

    const get = (id, isRequest = true) => {

        if (isRequest) {

            dispatch(request());
        }

        movieService.get(id).
            then(response => {

                if (!response.success) {

                    toast.error(response.message);

                    dispatch(fail());

                    return;
                }

                dispatch(success(response.data));
            }).
            catch(ex => {

                toast.error("the movie couldn't be fetched!");

                dispatch(fail("!"));
            });

        function success(data) { return { type: constant.GET_SUCCESS, payload: data }; }
        function fail() { return { type: constant.GET_FAIL }; }
        function request() { return { type: constant.GET_REQUEST }; }
    };

    const add = (movie, onSuccess) => {

        dispatch(request());

        movieService.add(movie).
            then(response => {

                if (!response.success) {

                    toast.error(response.message);

                    dispatch(fail());

                    return;
                }

                dispatch(success(response.data));

                if (onSuccess) {

                    onSuccess(response.data);
                }
            }).
            catch(ex => {

                toast.error("the movie couldn't be added!");

                dispatch(fail("!"));
            });

        function success(data) { return { type: constant.ADD_SUCCESS, payload: data }; }
        function fail() { return { type: constant.ADD_FAIL }; }
        function request() { return { type: constant.ADD_REQUEST }; }
    };

    const should = (dto, onSuccess) => {

        dispatch(request());

        movieService.should(dto).
            then(response => {

                if (!response.success) {

                    toast.error(response.message);

                    dispatch(fail());

                    return;
                }

                dispatch(success(response.data));

                if (onSuccess) {

                    onSuccess();
                }
            }).
            catch(ex => {

                toast.error("the movie couldn't be rated!");

                dispatch(fail("!"));
            });

        function success(data) { return { type: constant.SHOULD_SUCCESS, payload: data }; }
        function fail() { return { type: constant.SHOULD_FAIL }; }
        function request() { return { type: constant.SHOULD_REQUEST }; }
    };

    const addWatchList = (dto, onSuccess) => {

        dispatch(request());

        movieService.addWatchList(dto).
            then(response => {

                if (!response.success) {

                    toast.error(response.message);

                    dispatch(fail());

                    return;
                }

                dispatch(success(response.data));

                if (onSuccess) {

                    onSuccess();
                }
            }).
            catch(ex => {

                toast.error("The movie couldn't be added to your watching list!");

                dispatch(fail("!"));
            });

        function success(data) {
            return { type: constant.ADD_LIST_SUCCESS, payload: data };
        }
        function fail() { return { type: constant.ADD_LIST_FAIL }; }
        function request() { return { type: constant.ADD_LIST_REQUEST }; }
    };

    const search = (key) => {

        dispatch(request());

        movieService.search(key).
            then(response => {

                if (!response.success) {

                    toast.error(response.message);

                    dispatch(fail());

                    return;
                }

                dispatch(success(response.data));
            }).
            catch(ex => {

                toast.error("movies couldn't be fetched!");

                dispatch(fail("!"));
            });

        function success(data) { return { type: constant.SEARCH_SUCCESS, payload: data }; }
        function fail() { return { type: constant.SEARCH_FAIL }; }
        function request() { return { type: constant.SEARCH_REQUEST }; }
    };

    const goToDetail = (id) =>{

        history.push("/movie/" + id)
    }

    const reset = () => {

        dispatch({ type: constant.RESET })
    }

    const paginate = (dto, onSuccess) => {

        dto = { ...{ limit: 12 }, ...dto };

        dispatch(request());

        movieService.paginate(dto).
            then(response => {

                if (!response.success) {

                    toast.error(response.message);

                    dispatch(fail());

                    return;
                }

                dispatch(success(response.data));

                if (onSuccess) {

                    onSuccess();
                }
            }).
            catch(ex => {

                toast.error("movies couldn't be fetched!");

                dispatch(fail("!"));
            });

        function success(data) { return { type: constant.PAGINATE_SUCCESS, payload: data }; }
        function fail() { return { type: constant.PAGINATE_FAIL }; }
        function request() { return { type: constant.PAGINATE_REQUEST }; }
    };

    return (
        <MovieContext.Provider value={[state,
            {
                add,
                search,
                paginate,
                get,
                should,
                reset,
                addWatchList,
                goToDetail
            }]}>
            {props.children}
        </MovieContext.Provider>
    );
};

